export * from "./StoreDetails.builder";
